/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BadgeNotification, BadgeNotificationInline, BadgeNotificationAvatar, BadgeDefault, BadgeInformationInline, BadgeInformationAvatar, BadgeTopLeft, BadgeTopRight, BadgeBottomLeft, BadgeBottomRight, BadgeImgWithIcon, BadgeMailIcon} from 'Docs/uilib/components/badge/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsxs(_components.h3, {
      children: ["Setting property ", _jsx(_components.code, {
        children: "variant"
      })]
    }), "\n", _jsxs(_components.h4, {
      children: ["default ", _jsx(_components.code, {
        children: "variant"
      }), " is 'information'"]
    }), "\n", _jsx(BadgeDefault, {}), "\n", _jsx(BadgeInformationInline, {}), "\n", _jsx(BadgeInformationAvatar, {}), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "variant"
      }), " 'notification'"]
    }), "\n", _jsx(BadgeNotification, {}), "\n", _jsx(BadgeNotificationInline, {}), "\n", _jsx(BadgeNotificationAvatar, {}), "\n", _jsxs(_components.h3, {
      children: ["Setting property ", _jsx(_components.code, {
        children: "horizontal"
      }), " and ", _jsx(_components.code, {
        children: "vertical"
      })]
    }), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "vertical"
      }), " 'top' ", _jsx(_components.code, {
        children: "horizontal"
      }), " 'left'"]
    }), "\n", _jsx(BadgeTopLeft, {}), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "vertical"
      }), " 'top' ", _jsx(_components.code, {
        children: "horizontal"
      }), " 'right'"]
    }), "\n", _jsx(BadgeTopRight, {}), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "vertical"
      }), " 'bottom' ", _jsx(_components.code, {
        children: "horizontal"
      }), " 'left'"]
    }), "\n", _jsx(BadgeBottomLeft, {}), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "vertical"
      }), " 'bottom' ", _jsx(_components.code, {
        children: "horizontal"
      }), " 'right'"]
    }), "\n", _jsx(BadgeBottomRight, {}), "\n", _jsx(_components.h3, {
      children: "Alternatives"
    }), "\n", _jsx(BadgeImgWithIcon, {}), "\n", _jsx(BadgeMailIcon, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
